import { useFormStore } from '@/stores/form'
import bulkFileApi from '@/services/bulkFile'
import router from '@/router'
import client_config from '@/assets/json/client_config.json'
import lookups from '@/assets/json/clientLookups.json'

const checkPersonUnifiedNumberChange = async () => {
  const formStore = useFormStore()
  const { IssueGreenResidencyForSkilledPerson, IssueGreenResidencyForInvestorOrPartner } =
    lookups.ServiceTransactions
  const serviceTransactionId = router.currentRoute.value.params.serviceId
  if (
    serviceTransactionId &&
    +serviceTransactionId !== IssueGreenResidencyForSkilledPerson &&
    +serviceTransactionId !== IssueGreenResidencyForInvestorOrPartner
  ) {
    return
  }

  const { unifiedNumber, departmentCode, serviceYear, serviceCode, sequenceNumber } =
    formStore?.form.values || {}

  if (unifiedNumber && departmentCode && serviceYear && serviceCode && sequenceNumber) {
    try {
      const childEstablishmentId = router.currentRoute.value?.params?.childEstablishmentId
      const personImmigrationFileInput = {
        unifiedNumber: unifiedNumber,
        serviceTransactionId: serviceTransactionId,
        fileDepartmentCode: departmentCode,
        fileYear: serviceYear,
        fileTypeCode: serviceCode,
        fileSequance: sequenceNumber,
        childEstablishmentId
      }
      const params = {
        serviceTransId: serviceTransactionId
      }
      const response = await bulkFileApi.prepareResiForEstab(personImmigrationFileInput, params)
      if (client_config.enablePreparingPersonImmigrationFileApi) {
        formStore.draft.request = {
          ...formStore.draft.request,
          ...response.data.residencyRequest,
          manageFields: {}
        }
      } else {
        formStore.draft.request = response
        formStore.draft.request.manageFields = {}
      }
      const { localHomePhone } = formStore?.draft?.request || {}

      if (
        localHomePhone &&
        localHomePhone.length > 5 &&
        localHomePhone.substring(0, 5) !== '00971'
      ) {
        formStore.form.setFieldValue({
          localHomePhone: undefined
        })
      }
      formStore.draft = {
        ...formStore.draft,
        withException: router.currentRoute.value.params.withException === 'true' ? true : false,
        applicantId: formStore.draft.request.applicantId,
        establishmentId: router.currentRoute.value.params.childEstablishmentId
      }

      if (formStore?.draft?.request && formStore?.draft?.request?.professionId) {
        if (
          +serviceTransactionId == IssueGreenResidencyForSkilledPerson &&
          +serviceTransactionId == IssueGreenResidencyForInvestorOrPartner
        ) {
          formStore.draft.request.manageFields.isProfessionIdDisabled = true
        }
      } else {
        if (formStore.draft.request.manageFields) {
          formStore.draft.request.manageFields.isProfessionIdDisabled = false
        }
      }

      if (formStore.draft.request.faithId) {
        formStore.draft.request.isFaithExistOnUDB = true
      }

      return response
    } catch (error) {
      formStore.draft.request = {}
      formStore.extraMap.showFinesWarningMessage = false
      console.error('use922Actions', error)
    }
  }
}

export default function () {
  return {
    checkPersonUnifiedNumberChange
  }
}
